import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Box, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export default function BuzzModal({
  open,
  onClose,
  title,
  children,
  width,
  disable = false,
}) {
  return (
    <Dialog
      open={open}
      maxWidth={false}
      onClose={disable ? undefined : onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <Box display="flex" width={width} pr={1}>
        {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
        <Box flexGrow={1} />
        {typeof onClose === 'function' && (
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}
